var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9393 3.11914C7.59784 3.11914 2.45117 8.26581 2.45117 14.6072C2.45117 20.9487 7.59784 26.0953 13.9393 26.0953C20.2807 26.0953 25.4274 20.9487 25.4274 14.6072C25.4274 8.26581 20.2807 3.11914 13.9393 3.11914ZM12.7905 23.7173C8.25266 23.1544 4.74879 19.2944 4.74879 14.6072C4.74879 13.895 4.8407 13.2172 4.99004 12.5509L10.4928 18.0537V19.2025C10.4928 20.4662 11.5268 21.5001 12.7905 21.5001V23.7173ZM20.7172 20.7993C20.4186 19.8688 19.5684 19.2025 18.5345 19.2025H17.3857V15.756C17.3857 15.1242 16.8687 14.6072 16.2369 14.6072H9.34403V12.3096H11.6416C12.2735 12.3096 12.7905 11.7927 12.7905 11.1608V8.86319H15.0881C16.3518 8.86319 17.3857 7.82926 17.3857 6.56557V6.09456C20.7517 7.46164 23.1297 10.7587 23.1297 14.6072C23.1297 16.9968 22.2107 19.168 20.7172 20.7993Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/globeIcon.e3bb42d6cfac3c94ac7cda3267020721.svg";
export { ForwardRef as ReactComponent };